import { render, staticRenderFns } from "./NovelDeleteConfirm.vue?vue&type=template&id=646d0723&scoped=true&"
import script from "./NovelDeleteConfirm.vue?vue&type=script&lang=ts&"
export * from "./NovelDeleteConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./NovelDeleteConfirm.vue?vue&type=style&index=0&id=646d0723&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646d0723",
  null
  
)

export default component.exports